/**
 * Función helper para manejar la navegación con soporte para abrir en nueva pestaña
 * @param {string} url - URL a navegar
 * @param {Event} event - Evento del click
 * @param {Function} navigate - Función de navegación de React Router
 */
export const handleNavigation = (url, event, navigate) => {
    if (event.ctrlKey || event.metaKey) {
        // Abrir en nueva pestaña
        window.open(url, '_blank');
    } else {
        // Navegación normal
        navigate(url);
    }
};

/**
 * Función helper para manejar enlaces externos con soporte para nueva pestaña
 * @param {string} url - URL externa
 * @param {Event} event - Evento del click
 */
export const handleExternalNavigation = (url, event) => {
    if (event.ctrlKey || event.metaKey) {
        // Abrir en nueva pestaña
        window.open(url, '_blank');
    } else {
        // Navegación normal
        window.open(url, '_blank');
    }
}; 